import { z } from 'zod';

export const MEETING_FORMATS = ['Онлайн', 'Оффлайн'] as const;
export const MEETING_TYPES = ['Продажа', 'Демо', 'Аудит'] as const;

export const DEFAULT_FUNNEL_LABEL = 'Лиды';
export const LEGACY_FUNNEL_LABEL = 'Лид';
export const CURRENT_USER_LABEL = 'Я';

export type MeetingFormat = (typeof MEETING_FORMATS)[number];
export type MeetingType = (typeof MEETING_TYPES)[number];

export type FunnelKind = 'lead' | 'smart_process' | 'deal';

export type FunnelOption = {
  label: string;
  kind: FunnelKind;
  entityTypeId: number | null;
  dealCategoryId: number | null;
};

export type MeetingSlotFormValues = {
  dealId: number | null;
  dealLabel: string;
  dealQuery: string;
  funnelLabel: string;
  leadCrmRef: string | null;
  leadId: number | null;
  leadLabel: string;
  leadQuery: string;
  meetingFormat: MeetingFormat;
  meetingType: MeetingType;
  presenterId: number | null;
  presenterName: string;
  presenterQuery: string;
  projectId: number | null;
  projectQuery: string;
  projectTitle: string;
};

export const meetingSlotFormSchema = z.object({
  dealId: z.number().nullable(),
  dealLabel: z.string(),
  dealQuery: z.string(),
  funnelLabel: z.string().min(1),
  leadCrmRef: z.string().nullable(),
  leadId: z.number().nullable(),
  leadLabel: z.string(),
  leadQuery: z.string(),
  meetingFormat: z.enum(MEETING_FORMATS),
  meetingType: z.enum(MEETING_TYPES),
  presenterId: z.number().nullable(),
  presenterName: z.string(),
  presenterQuery: z.string(),
  projectId: z.number().nullable(),
  projectQuery: z.string(),
  projectTitle: z.string(),
});

export function getDefaultMeetingSlotFormValues(): MeetingSlotFormValues {
  return {
    dealId: null,
    dealLabel: '',
    dealQuery: '',
    funnelLabel: DEFAULT_FUNNEL_LABEL,
    leadCrmRef: null,
    leadId: null,
    leadLabel: '',
    leadQuery: '',
    meetingFormat: MEETING_FORMATS[0],
    meetingType: MEETING_TYPES[0],
    presenterId: null,
    presenterName: '',
    presenterQuery: '',
    projectId: null,
    projectQuery: '',
    projectTitle: '',
  };
}
